import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  TextField,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";

const StatisticsFilters = ({
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  selectedPreset,
  setSelectedPreset,
  loading,
  onRefresh,
  onClearDates,
  onPresetSelection,
  formatDate,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {/* Header */}
      <Box sx={{ mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
            Statystyki
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Przegląd przychodów i sprzedaży karnetów
          </Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
          disabled={loading}
        >
          Odśwież
        </Button>
      </Box>

      {/* Quick Preset Buttons */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Szybki wybór okresu
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          <Chip
            label="Ten tydzień"
            onClick={() => onPresetSelection('thisWeek')}
            color={selectedPreset === 'thisWeek' ? 'primary' : 'default'}
            variant={selectedPreset === 'thisWeek' ? 'filled' : 'outlined'}
            clickable
          />
          <Chip
            label="Ostatni tydzień"
            onClick={() => onPresetSelection('lastWeek')}
            color={selectedPreset === 'lastWeek' ? 'primary' : 'default'}
            variant={selectedPreset === 'lastWeek' ? 'filled' : 'outlined'}
            clickable
          />
          <Chip
            label="Ten miesiąc"
            onClick={() => onPresetSelection('thisMonth')}
            color={selectedPreset === 'thisMonth' ? 'primary' : 'default'}
            variant={selectedPreset === 'thisMonth' ? 'filled' : 'outlined'}
            clickable
          />
          <Chip
            label="Ostatni miesiąc"
            onClick={() => onPresetSelection('lastMonth')}
            color={selectedPreset === 'lastMonth' ? 'primary' : 'default'}
            variant={selectedPreset === 'lastMonth' ? 'filled' : 'outlined'}
            clickable
          />
          <Chip
            label="Ten rok"
            onClick={() => onPresetSelection('thisYear')}
            color={selectedPreset === 'thisYear' ? 'primary' : 'default'}
            variant={selectedPreset === 'thisYear' ? 'filled' : 'outlined'}
            clickable
          />
          <Chip
            label="Ostatnie 30 dni"
            onClick={() => onPresetSelection('last30Days')}
            color={selectedPreset === 'last30Days' ? 'primary' : 'default'}
            variant={selectedPreset === 'last30Days' ? 'filled' : 'outlined'}
            clickable
          />
          <Chip
            label="Cały okres"
            onClick={() => onPresetSelection('allTime')}
            color={selectedPreset === 'allTime' ? 'primary' : 'default'}
            variant={selectedPreset === 'allTime' ? 'filled' : 'outlined'}
            clickable
          />
        </Box>
      </Paper>

      {/* Manual Date Range Filter */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Zakres dat (opcjonalnie)
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={5}>
            <TextField
              label="Data od"
              type="date"
              fullWidth
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size={isMobile ? "small" : "medium"}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              label="Data do"
              type="date"
              fullWidth
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size={isMobile ? "small" : "medium"}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'row', sm: 'column' } }}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  setSelectedPreset("");
                  onRefresh();
                }}
                disabled={loading}
                size={isMobile ? "small" : "medium"}
              >
                Zastosuj
              </Button>
              <Button
                variant="outlined"
                fullWidth
                onClick={onClearDates}
                size={isMobile ? "small" : "medium"}
              >
                Wyczyść
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {dateFrom || dateTo
            ? `Okres: ${formatDate(dateFrom)} - ${formatDate(dateTo)}`
            : "Pokazuję wszystkie dane"}
        </Typography>
      </Paper>
    </>
  );
};

export default StatisticsFilters;
